/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps, IconSize} from '../../types/types';
import useIconDLS from './../useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Shipment-Outline Icon component.
 */
export const AssetShipmentOutlined = (props: IconProps) => {
  const {color, size = IconSize.large, stroke} = props;
  const {iconSize} = useIconDLS({color, size});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none'>
      <path d="M36.0002 10H11.2729V30H36.0002V10Z" stroke={stroke as any} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M28.7272 10H18.5454V19.3333H28.7272V10Z" stroke={stroke as any} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.90909 14H4" stroke={stroke as any} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.90909 19.333H4" stroke={stroke as any} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.90909 24.667H4" stroke={stroke as any} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default AssetShipmentOutlined;
